/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Modal_CloseInputs */

const de_commons_modal_close = /** @type {(inputs: Commons_Modal_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

/** @type {(inputs: Commons_Modal_CloseInputs) => LocalizedString} */
const en_commons_modal_close = de_commons_modal_close;

/**

* @param {Commons_Modal_CloseInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_modal_close = /** @type {((inputs?: Commons_Modal_CloseInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Modal_CloseInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_modal_close(inputs)
	return en_commons_modal_close(inputs)
});